import Skeleton from "@/app/components/ui-elements/skeleton";

export default function LoadingProjects({displayFull}: {displayFull: boolean}) {
  return (
    <main className="p-8 mx-auto">
      {displayFull && (
        <>
        <Skeleton className="h-[300px] w-full" />
        <Skeleton className="h-[300px] w-full mb-8" />
        <Skeleton className="h-[300px] w-1/2 ms-auto" />
        <Skeleton className="h-[300px] w-1/2 mb-8 ms-auto" />
        </>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="space-y-4">
            <Skeleton className="aspect-video h-[300px] w-full" />
          </div>
        ))}
      </div>
    </main>
  );
}